// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: H_rEivuFt7mL
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import ContractInstanceCard from "../../ContractInstanceCard"; // plasmic-import: qsV-vn7hyUle/component
import AddMilestoneButton from "../../AddMilestoneButton"; // plasmic-import: yPGrNdbQh-CF/component
import MilestoneInstance from "../../MilestoneInstance"; // plasmic-import: ixb95naDvLzR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicContractInstance.module.css"; // plasmic-import: H_rEivuFt7mL/css
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: z3YAObc8gkKH/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: jmxAADuTvJ3W/icon

createPlasmicElementProxy;

export const PlasmicContractInstance__VariantProps = new Array();

export const PlasmicContractInstance__ArgProps = new Array(
  "contractName",
  "amountPaid",
  "budgetAmount"
);

const $$ = {};

function PlasmicContractInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__nFhHg)}>
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__rtiil)}>
                <div
                  data-plasmic-name={"title2"}
                  data-plasmic-override={overrides.title2}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title2
                  )}
                >
                  {"Contract"}
                </div>
                <div
                  data-plasmic-name={"title"}
                  data-plasmic-override={overrides.title}
                  className={classNames(projectcss.all, sty.title)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "Social Media Marketing",
                    value: args.contractName,
                    className: classNames(sty.slotTargetContractName)
                  })}
                </div>
                <div
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {"Client"}
                </div>
                <div
                  data-plasmic-name={"clientNameStack"}
                  data-plasmic-override={overrides.clientNameStack}
                  className={classNames(projectcss.all, sty.clientNameStack)}
                >
                  <div
                    data-plasmic-name={"clientName"}
                    data-plasmic-override={overrides.clientName}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.clientName
                    )}
                  >
                    {"Hello"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title10"}
                  data-plasmic-override={overrides.title10}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title10
                  )}
                >
                  {"Budget:"}
                </div>
                <div
                  data-plasmic-name={"budgetAmount"}
                  data-plasmic-override={overrides.budgetAmount}
                  className={classNames(projectcss.all, sty.budgetAmount)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "$1024.00",
                    value: args.budgetAmount,
                    className: classNames(sty.slotTargetBudgetAmount)
                  })}
                </div>
                <div
                  data-plasmic-name={"title14"}
                  data-plasmic-override={overrides.title14}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title14
                  )}
                >
                  {"Amount Paid:"}
                </div>
                <div
                  data-plasmic-name={"amountPaidText"}
                  data-plasmic-override={overrides.amountPaidText}
                  className={classNames(projectcss.all, sty.amountPaidText)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "$1024.00",
                    value: args.amountPaid,
                    className: classNames(sty.slotTargetAmountPaid)
                  })}
                </div>
                <div
                  data-plasmic-name={"contractTerms"}
                  data-plasmic-override={overrides.contractTerms}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.contractTerms
                  )}
                >
                  {"Contract Terms:"}
                </div>
                <div
                  data-plasmic-name={"downloadContract"}
                  data-plasmic-override={overrides.downloadContract}
                  className={classNames(projectcss.all, sty.downloadContract)}
                >
                  <Layer11Icon
                    className={classNames(projectcss.all, sty.svg__eXPqq)}
                    role={"img"}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox__ikAne)}
                  >
                    <IconIcon
                      className={classNames(projectcss.all, sty.svg___6OZ2)}
                      role={"img"}
                    />
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__i1Y0V)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox__iiiE)}
                />

                <div
                  data-plasmic-name={"inProgressStack"}
                  data-plasmic-override={overrides.inProgressStack}
                  className={classNames(projectcss.all, sty.inProgressStack)}
                >
                  <div
                    data-plasmic-name={"title6"}
                    data-plasmic-override={overrides.title6}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title6
                    )}
                  >
                    {"In Progress"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__wxwhD)}
                  >
                    <div
                      data-plasmic-name={"title17"}
                      data-plasmic-override={overrides.title17}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title17
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title18"}
                      data-plasmic-override={overrides.title18}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title18
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title19"}
                      data-plasmic-override={overrides.title19}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title19
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title20"}
                      data-plasmic-override={overrides.title20}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title20
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"inProgressCards"}
                    data-plasmic-override={overrides.inProgressCards}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.inProgressCards)}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__svZu
                      )}
                    />

                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__yIcyj
                      )}
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"awaitingApprovalStack"}
                  data-plasmic-override={overrides.awaitingApprovalStack}
                  className={classNames(
                    projectcss.all,
                    sty.awaitingApprovalStack
                  )}
                >
                  <div
                    data-plasmic-name={"title7"}
                    data-plasmic-override={overrides.title7}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title7
                    )}
                  >
                    {"Awaiting Client Approval"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__rCSlo)}
                  >
                    <div
                      data-plasmic-name={"title21"}
                      data-plasmic-override={overrides.title21}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title21
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title22"}
                      data-plasmic-override={overrides.title22}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title22
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title23"}
                      data-plasmic-override={overrides.title23}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title23
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title24"}
                      data-plasmic-override={overrides.title24}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title24
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"awaitingApprovalCards"}
                    data-plasmic-override={overrides.awaitingApprovalCards}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.awaitingApprovalCards
                    )}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__olq5L
                      )}
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"awaitingEscrowStack"}
                  data-plasmic-override={overrides.awaitingEscrowStack}
                  className={classNames(
                    projectcss.all,
                    sty.awaitingEscrowStack
                  )}
                >
                  <div
                    data-plasmic-name={"title9"}
                    data-plasmic-override={overrides.title9}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title9
                    )}
                  >
                    {"Awaiting Escrow Payment"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___5JJt2)}
                  >
                    <div
                      data-plasmic-name={"title25"}
                      data-plasmic-override={overrides.title25}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title25
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title26
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title27"}
                      data-plasmic-override={overrides.title27}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title27
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title28"}
                      data-plasmic-override={overrides.title28}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title28
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"awaitingEscrowCards"}
                    data-plasmic-override={overrides.awaitingEscrowCards}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.awaitingEscrowCards
                    )}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__qZh1
                      )}
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"awaitingPaymentStack"}
                  data-plasmic-override={overrides.awaitingPaymentStack}
                  className={classNames(
                    projectcss.all,
                    sty.awaitingPaymentStack
                  )}
                >
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Awaiting Payment"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__xr2JF)}
                  >
                    <div
                      data-plasmic-name={"title34"}
                      data-plasmic-override={overrides.title34}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title34
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title35"}
                      data-plasmic-override={overrides.title35}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title35
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title36"}
                      data-plasmic-override={overrides.title36}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title36
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title37"}
                      data-plasmic-override={overrides.title37}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title37
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"awaitingPaymentCards"}
                    data-plasmic-override={overrides.awaitingPaymentCards}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.awaitingPaymentCards
                    )}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__rliBt
                      )}
                      status={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__frBjP
                          )}
                        >
                          {"Not Paid"}
                        </div>
                      }
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"upcomingMilestonesStack"}
                  data-plasmic-override={overrides.upcomingMilestonesStack}
                  className={classNames(
                    projectcss.all,
                    sty.upcomingMilestonesStack
                  )}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__qCtMs)}
                  >
                    <div
                      data-plasmic-name={"title15"}
                      data-plasmic-override={overrides.title15}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title15
                      )}
                    >
                      {"Upcoming Milestones"}
                    </div>
                    <Stack__
                      as={"button"}
                      data-plasmic-name={"requestPaymentButton"}
                      data-plasmic-override={overrides.requestPaymentButton}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        projectcss.button,
                        sty.requestPaymentButton
                      )}
                      ref={ref => {
                        $refs["requestPaymentButton"] = ref;
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__iKdf2
                        )}
                      >
                        {"Request Next Payment"}
                      </div>
                    </Stack__>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__zEx76)}
                  >
                    <div
                      data-plasmic-name={"title38"}
                      data-plasmic-override={overrides.title38}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title38
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title39"}
                      data-plasmic-override={overrides.title39}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title39
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title40"}
                      data-plasmic-override={overrides.title40}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title40
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title41"}
                      data-plasmic-override={overrides.title41}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title41
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"upcomingMilestonesCards"}
                    data-plasmic-override={overrides.upcomingMilestonesCards}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.upcomingMilestonesCards
                    )}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__k4XX5
                      )}
                      status={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__i9Hhj
                          )}
                        >
                          {"Not Paid"}
                        </div>
                      }
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"disputesStack"}
                  data-plasmic-override={overrides.disputesStack}
                  className={classNames(projectcss.all, sty.disputesStack)}
                >
                  <div
                    data-plasmic-name={"title11"}
                    data-plasmic-override={overrides.title11}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title11
                    )}
                  >
                    {"Disputes"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__xbHrm)}
                  >
                    <div
                      data-plasmic-name={"title29"}
                      data-plasmic-override={overrides.title29}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title29
                      )}
                    >
                      {"Amount"}
                    </div>
                    <div
                      data-plasmic-name={"title31"}
                      data-plasmic-override={overrides.title31}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title31
                      )}
                    >
                      {"Status"}
                    </div>
                    <div
                      data-plasmic-name={"title32"}
                      data-plasmic-override={overrides.title32}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title32
                      )}
                    >
                      {"Milestone #"}
                    </div>
                    <div
                      data-plasmic-name={"title33"}
                      data-plasmic-override={overrides.title33}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title33
                      )}
                    >
                      {"Date"}
                    </div>
                  </div>
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"disputesCards"}
                    data-plasmic-override={overrides.disputesCards}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.disputesCards)}
                  >
                    <ContractInstanceCard
                      amount={"$1043.00"}
                      className={classNames(
                        "__wab_instance",
                        sty.contractInstanceCard__c90Lx
                      )}
                    />
                  </Stack__>
                </div>
                <div
                  data-plasmic-name={"milestoneTitle"}
                  data-plasmic-override={overrides.milestoneTitle}
                  className={classNames(projectcss.all, sty.milestoneTitle)}
                >
                  <div
                    data-plasmic-name={"title30"}
                    data-plasmic-override={overrides.title30}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title30
                    )}
                  >
                    {"Milestone Timeline"}
                  </div>
                  <AddMilestoneButton
                    data-plasmic-name={"addMilestoneButton"}
                    data-plasmic-override={overrides.addMilestoneButton}
                    className={classNames(
                      "__wab_instance",
                      sty.addMilestoneButton
                    )}
                  />
                </div>
                <Stack__
                  as={"div"}
                  data-plasmic-name={"milestoneStack"}
                  data-plasmic-override={overrides.milestoneStack}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.milestoneStack)}
                >
                  <MilestoneInstance
                    className={classNames(
                      "__wab_instance",
                      sty.milestoneInstance__ynoH
                    )}
                  />

                  <MilestoneInstance
                    className={classNames(
                      "__wab_instance",
                      sty.milestoneInstance___56AoN
                    )}
                    milestoneNumber={
                      <div
                        data-plasmic-name={"milestoneNumber2"}
                        data-plasmic-override={overrides.milestoneNumber2}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.milestoneNumber2
                        )}
                      >
                        {"1"}
                      </div>
                    }
                  />

                  <MilestoneInstance
                    className={classNames(
                      "__wab_instance",
                      sty.milestoneInstance___4G7Jd
                    )}
                    milestoneNumber={
                      <div
                        data-plasmic-name={"milestoneNumber3"}
                        data-plasmic-override={overrides.milestoneNumber3}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.milestoneNumber3
                        )}
                      >
                        {"1"}
                      </div>
                    }
                  />
                </Stack__>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "topBar",
    "vertStack",
    "title2",
    "title",
    "title8",
    "clientNameStack",
    "clientName",
    "title10",
    "budgetAmount",
    "title14",
    "amountPaidText",
    "contractTerms",
    "downloadContract",
    "inProgressStack",
    "title6",
    "title17",
    "title18",
    "title19",
    "title20",
    "inProgressCards",
    "awaitingApprovalStack",
    "title7",
    "title21",
    "title22",
    "title23",
    "title24",
    "awaitingApprovalCards",
    "awaitingEscrowStack",
    "title9",
    "title25",
    "title26",
    "title27",
    "title28",
    "awaitingEscrowCards",
    "awaitingPaymentStack",
    "title13",
    "title34",
    "title35",
    "title36",
    "title37",
    "awaitingPaymentCards",
    "upcomingMilestonesStack",
    "title15",
    "requestPaymentButton",
    "title38",
    "title39",
    "title40",
    "title41",
    "upcomingMilestonesCards",
    "disputesStack",
    "title11",
    "title29",
    "title31",
    "title32",
    "title33",
    "disputesCards",
    "milestoneTitle",
    "title30",
    "addMilestoneButton",
    "milestoneStack",
    "milestoneNumber2",
    "milestoneNumber3"
  ],

  sidebar: ["sidebar"],
  topBar: ["topBar"],
  vertStack: [
    "vertStack",
    "title2",
    "title",
    "title8",
    "clientNameStack",
    "clientName",
    "title10",
    "budgetAmount",
    "title14",
    "amountPaidText",
    "contractTerms",
    "downloadContract",
    "inProgressStack",
    "title6",
    "title17",
    "title18",
    "title19",
    "title20",
    "inProgressCards",
    "awaitingApprovalStack",
    "title7",
    "title21",
    "title22",
    "title23",
    "title24",
    "awaitingApprovalCards",
    "awaitingEscrowStack",
    "title9",
    "title25",
    "title26",
    "title27",
    "title28",
    "awaitingEscrowCards",
    "awaitingPaymentStack",
    "title13",
    "title34",
    "title35",
    "title36",
    "title37",
    "awaitingPaymentCards",
    "upcomingMilestonesStack",
    "title15",
    "requestPaymentButton",
    "title38",
    "title39",
    "title40",
    "title41",
    "upcomingMilestonesCards",
    "disputesStack",
    "title11",
    "title29",
    "title31",
    "title32",
    "title33",
    "disputesCards",
    "milestoneTitle",
    "title30",
    "addMilestoneButton",
    "milestoneStack",
    "milestoneNumber2",
    "milestoneNumber3"
  ],

  title2: ["title2"],
  title: ["title"],
  title8: ["title8"],
  clientNameStack: ["clientNameStack", "clientName"],
  clientName: ["clientName"],
  title10: ["title10"],
  budgetAmount: ["budgetAmount"],
  title14: ["title14"],
  amountPaidText: ["amountPaidText"],
  contractTerms: ["contractTerms"],
  downloadContract: ["downloadContract"],
  inProgressStack: [
    "inProgressStack",
    "title6",
    "title17",
    "title18",
    "title19",
    "title20",
    "inProgressCards"
  ],

  title6: ["title6"],
  title17: ["title17"],
  title18: ["title18"],
  title19: ["title19"],
  title20: ["title20"],
  inProgressCards: ["inProgressCards"],
  awaitingApprovalStack: [
    "awaitingApprovalStack",
    "title7",
    "title21",
    "title22",
    "title23",
    "title24",
    "awaitingApprovalCards"
  ],

  title7: ["title7"],
  title21: ["title21"],
  title22: ["title22"],
  title23: ["title23"],
  title24: ["title24"],
  awaitingApprovalCards: ["awaitingApprovalCards"],
  awaitingEscrowStack: [
    "awaitingEscrowStack",
    "title9",
    "title25",
    "title26",
    "title27",
    "title28",
    "awaitingEscrowCards"
  ],

  title9: ["title9"],
  title25: ["title25"],
  title26: ["title26"],
  title27: ["title27"],
  title28: ["title28"],
  awaitingEscrowCards: ["awaitingEscrowCards"],
  awaitingPaymentStack: [
    "awaitingPaymentStack",
    "title13",
    "title34",
    "title35",
    "title36",
    "title37",
    "awaitingPaymentCards"
  ],

  title13: ["title13"],
  title34: ["title34"],
  title35: ["title35"],
  title36: ["title36"],
  title37: ["title37"],
  awaitingPaymentCards: ["awaitingPaymentCards"],
  upcomingMilestonesStack: [
    "upcomingMilestonesStack",
    "title15",
    "requestPaymentButton",
    "title38",
    "title39",
    "title40",
    "title41",
    "upcomingMilestonesCards"
  ],

  title15: ["title15"],
  requestPaymentButton: ["requestPaymentButton"],
  title38: ["title38"],
  title39: ["title39"],
  title40: ["title40"],
  title41: ["title41"],
  upcomingMilestonesCards: ["upcomingMilestonesCards"],
  disputesStack: [
    "disputesStack",
    "title11",
    "title29",
    "title31",
    "title32",
    "title33",
    "disputesCards"
  ],

  title11: ["title11"],
  title29: ["title29"],
  title31: ["title31"],
  title32: ["title32"],
  title33: ["title33"],
  disputesCards: ["disputesCards"],
  milestoneTitle: ["milestoneTitle", "title30", "addMilestoneButton"],
  title30: ["title30"],
  addMilestoneButton: ["addMilestoneButton"],
  milestoneStack: ["milestoneStack", "milestoneNumber2", "milestoneNumber3"],
  milestoneNumber2: ["milestoneNumber2"],
  milestoneNumber3: ["milestoneNumber3"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContractInstance__ArgProps,
          internalVariantPropNames: PlasmicContractInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContractInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContractInstance";
  } else {
    func.displayName = `PlasmicContractInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicContractInstance = Object.assign(
  // Top-level PlasmicContractInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    topBar: makeNodeComponent("topBar"),
    vertStack: makeNodeComponent("vertStack"),
    title2: makeNodeComponent("title2"),
    title: makeNodeComponent("title"),
    title8: makeNodeComponent("title8"),
    clientNameStack: makeNodeComponent("clientNameStack"),
    clientName: makeNodeComponent("clientName"),
    title10: makeNodeComponent("title10"),
    budgetAmount: makeNodeComponent("budgetAmount"),
    title14: makeNodeComponent("title14"),
    amountPaidText: makeNodeComponent("amountPaidText"),
    contractTerms: makeNodeComponent("contractTerms"),
    downloadContract: makeNodeComponent("downloadContract"),
    inProgressStack: makeNodeComponent("inProgressStack"),
    title6: makeNodeComponent("title6"),
    title17: makeNodeComponent("title17"),
    title18: makeNodeComponent("title18"),
    title19: makeNodeComponent("title19"),
    title20: makeNodeComponent("title20"),
    inProgressCards: makeNodeComponent("inProgressCards"),
    awaitingApprovalStack: makeNodeComponent("awaitingApprovalStack"),
    title7: makeNodeComponent("title7"),
    title21: makeNodeComponent("title21"),
    title22: makeNodeComponent("title22"),
    title23: makeNodeComponent("title23"),
    title24: makeNodeComponent("title24"),
    awaitingApprovalCards: makeNodeComponent("awaitingApprovalCards"),
    awaitingEscrowStack: makeNodeComponent("awaitingEscrowStack"),
    title9: makeNodeComponent("title9"),
    title25: makeNodeComponent("title25"),
    title26: makeNodeComponent("title26"),
    title27: makeNodeComponent("title27"),
    title28: makeNodeComponent("title28"),
    awaitingEscrowCards: makeNodeComponent("awaitingEscrowCards"),
    awaitingPaymentStack: makeNodeComponent("awaitingPaymentStack"),
    title13: makeNodeComponent("title13"),
    title34: makeNodeComponent("title34"),
    title35: makeNodeComponent("title35"),
    title36: makeNodeComponent("title36"),
    title37: makeNodeComponent("title37"),
    awaitingPaymentCards: makeNodeComponent("awaitingPaymentCards"),
    upcomingMilestonesStack: makeNodeComponent("upcomingMilestonesStack"),
    title15: makeNodeComponent("title15"),
    requestPaymentButton: makeNodeComponent("requestPaymentButton"),
    title38: makeNodeComponent("title38"),
    title39: makeNodeComponent("title39"),
    title40: makeNodeComponent("title40"),
    title41: makeNodeComponent("title41"),
    upcomingMilestonesCards: makeNodeComponent("upcomingMilestonesCards"),
    disputesStack: makeNodeComponent("disputesStack"),
    title11: makeNodeComponent("title11"),
    title29: makeNodeComponent("title29"),
    title31: makeNodeComponent("title31"),
    title32: makeNodeComponent("title32"),
    title33: makeNodeComponent("title33"),
    disputesCards: makeNodeComponent("disputesCards"),
    milestoneTitle: makeNodeComponent("milestoneTitle"),
    title30: makeNodeComponent("title30"),
    addMilestoneButton: makeNodeComponent("addMilestoneButton"),
    milestoneStack: makeNodeComponent("milestoneStack"),
    milestoneNumber2: makeNodeComponent("milestoneNumber2"),
    milestoneNumber3: makeNodeComponent("milestoneNumber3"),
    // Metadata about props expected for PlasmicContractInstance
    internalVariantProps: PlasmicContractInstance__VariantProps,
    internalArgProps: PlasmicContractInstance__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicContractInstance;
/* prettier-ignore-end */
